import { API_ENDPOINTS } from '../config/api.config';

/** Save forecast hours for a project/day (effort in minutes). Pass 0 to delete. */
export async function upsertForecastCell({ userId, projectId, date, effortMinutes }) {
  const response = await fetch(API_ENDPOINTS.FORECAST_CELLS, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      user_id: userId,
      project_id: projectId,
      date,
      effort_minutes: effortMinutes,
    }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    const msg = err?.error ?? err?.message;
    throw new Error(msg != null && String(msg).trim() ? String(msg) : 'Failed to save forecast');
  }
  return response.json();
}

export async function fetchForecastConfig() {
  const response = await fetch(API_ENDPOINTS.FORECAST_CONFIG);
  if (!response.ok) {
    throw new Error('Failed to load forecast config');
  }
  return response.json();
}

export function hoursToMinutes(hours) {
  const h = Number(String(hours).replace(',', '.'));
  if (Number.isNaN(h) || h <= 0) return 0;
  return Math.round(h * 60);
}

export function minutesToHours(minutes) {
  if (!minutes) return '';
  return Math.round((Number(minutes) / 60) * 100) / 100;
}
